import type { VisualState } from "../services/conversation/state-machine";

interface StateRailProps {
  states: VisualState[];
  activeState: VisualState;
  onSelect: (state: VisualState) => void;
}

export function StateRail({ states, activeState, onSelect }: StateRailProps) {
  return (
    <div className="panel-section">
      <h2>状态视频</h2>
      <div className="state-grid">
        {states.map((state) => (
          <button
            key={state}
            type="button"
            className={state === activeState ? "selected" : ""}
            data-state={state}
            aria-pressed={state === activeState}
            onClick={() => onSelect(state)}
          >
            {state}
          </button>
        ))}
      </div>
    </div>
  );
}
